
import React from 'react';
import { createRoot } from 'react-dom/client';
import {WrapApp, App} from './App';

import {BrowserRouter as Router} from 'react-router-dom'; // se non s'importa in questo modo si ottiene l'errore: "locationProp is undefined"

const root = createRoot(document.getElementById("root"))
root.render(
    <App/>
            // <Router>
            //     <WrapApp/>
            // </Router>
);